import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import InviteGuestForm from '../InviteGuestForm';
import Popup from '../../../common/Popup';
import styles from './styles.styl';

const InviteGuestPopup = ({ opened, onClose, intl: { formatMessage } }) => {
  return (
    <Popup
      opened={opened}
      className={styles.invitePopup}
      white
      title={formatMessage({ id: 'virtualVisit.inviteGuest.title' })}
      onClose={onClose}
    >
      <InviteGuestForm close={onClose} />
    </Popup>
  );
};

InviteGuestPopup.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(InviteGuestPopup);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/InviteGuestPopup/index.jsx